import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { noop, setPaypalTotalPrice } from '../../../lib/utilities';
import { handleView } from '../handle_view';
import { Pdp } from '../../_flux/components/sidebar/pdp';
import { showAction } from '../../_flux/actions/wheel_alignment_info_light_box_actions';
import { showAction as showFsfNotAvailableLightBox } from '../../_flux/actions/fsf_not_available_light_box_actions';
import { open } from '../../_modules/google_analytics/wheel_alignment_info_light_box';
import LightboxActions, {
  openAction as openCarFittingStationFinder,
  goToPageAction as goToFsfPage,
} from '../../_flux/actions/lightbox_actions';
import { showAction as openMotoFittingStationFinder } from '../../_flux/actions/fsf_moto_light_box_actions';
import ActiveStationStore from '../../_flux/stores/active_station_store';
import calculateSetPrice from '../../_flux/helper/calculate_set_price';
import { ProductsStore } from '../../_flux/stores/products_store';
import { Pdp as PdpStore } from '../../_flux/stores/sidebar/pdp';
import { FittingStationStore } from '../../_flux/stores/fitting_station_store';
import { loadStations } from '../../_modules/fitting_station/load_stations';
import { loadStationsWithQuantity } from '../../_modules/fitting_station/load_stations_with_quantity';
import FittingStationFinderConstants from '../../_flux/constants/fitting_station_finder_constants';
import ActiveStationsActions, { fetchInitialStationAction } from '../../_flux/actions/active_station_actions';
import { updateAction as updateProduct } from '../../_flux/actions/products_actions';
import { types } from '../../_constants/product/types';
import { show as showFriendbuyLightBox } from '../../_flux/actions/friendbuy_light_box_actions';
import { showQuantityAndPriceRow } from '../../_flux/actions/sidebar/pdp';
import { show, hide } from '../../_flux/actions/postcode_light_box_actions';
import { bind } from '../../_modules/function/bind';
import { doAll } from '../../_modules/helper/doAll';
import PostcodeStore from '../../_flux/stores/postcode_store';
import MapStore from '../../_flux/stores/map_store';
import parseGoogleLatLng from '../../_flux/helper/parse_google_lat_lng';
import { FsfPages } from '../../_constants/fsf_pages';
import onChangeStationClick from '../../_flux/components/sidebar/actions/on_change_station_click';
import onRemoveStationClick from '../../_flux/components/sidebar/actions/on_remove_station_click';
import onRemoveCrossSellClick from '../../_flux/components/sidebar/actions/on_remove_cross_sell_click';
import onCrossSellDetailsClick from '../../_flux/components/sidebar/actions/on_cross_sell_details_click';
import isFSFDisabled from '../../_flux/helper/disable_fsf_for_store';
import { featureFlags } from '../../_constants/feature_flags';
import { getCalculatedDiscountAmount } from '../../utilities/discounts';
import { validatePostcode } from '../../validator/PostcodeAutocompleteValidator';
import { AddToCart } from '../../_flux/components/sidebar/rows/add_to_cart';
import Translation from '../../_flux/components/translation/translation';
import { Price } from '../../_flux/components/sidebar/rows/price';
import toDangerousReactHtml from '../../_flux/helper/to_dangerous_react_html';
import { loadAdPDP } from '../../_modules/google_analytics/product/product_tiles';
import { getMap } from '../../_flux/helper/gmap';
import { loadGoogleMapDependencies } from '../../_global/initGoogleMapDependencies';
import { CrossSellProductStore } from '../../_flux/stores/cross_sell_product_store';
import { show as showClearanceLightbox } from '../../_flux/actions/clearance_info_light_box_actions';
import ProductPage from '../../_pages/product_page';
import { addLoadingAction, removeLoadingAction } from '../../_flux/actions/voucher_code_light_box_actions';
import { showAction as lockUi, hideAction as unlockUi } from '../../_flux/actions/ui_lock_actions';

const stores = {
  activeStationState: ActiveStationStore,
  fittingStationState: FittingStationStore,
  productsState: ProductsStore,
  pdpState: PdpStore,
  crossSellProductStore: CrossSellProductStore,
};

function render({ activeStationState, fittingStationState, productsState, pdpState, crossSellProductStore }, options) {
  let [product] = productsState;
  if (!product || (product && product.fromTopCart)) {
    product = TYROOLA.initialFluxStates.product;
    product = {
      ...product,
      crossSellProductStore,
      setPrice: calculateSetPrice(product.qty, product.price, {
        buy4pay3: product.buy4pay3,
        off15: product.off15Perc,
        cashback100: product.cashback100,
      }),
    };
  }
  const { buy4pay3, clearance, cashback100 } = product;
  const { loadingPrices: loadingStationPrices } = fittingStationState;
  const { quantityAndPriceRowVisible } = pdpState;
  const { activeStation, wheelAlignment, initialLoading } = activeStationState;
  const isMpsProduct =
    activeStation &&
    activeStation.hasOwnProperty('isMarketplaceSeller') &&
    activeStation.hasOwnProperty('productStock') &&
    activeStation.isMarketplaceSeller === true &&
    activeStation.productStock.hasOwnProperty('frontendPrice');
  const mpsProductStock = isMpsProduct ? activeStation.productStock : null;
  const finalItemPrice = mpsProductStock ? mpsProductStock.frontendPrice : product.price;
  const setPrice = calculateSetPrice(product.qty, finalItemPrice, { cashback100 });
  const { voucherData } = TYROOLA.initialFluxStates;

  const [fittingStationStreet, fittingStationSuburb, postcode] = activeStation ? activeStation.address.split(', ') : [];
  const fittingPrice = activeStation ? activeStation.expenses.fitting : 0;
  const wheelAlignmentQuantity = !activeStation
    ? 0
    : wheelAlignment.wheels2.indexOf(activeStation.id) !== -1
    ? 2
    : wheelAlignment.wheels4.indexOf(activeStation.id) !== -1
    ? 4
    : 0;

  const wheelAlignmentPrice = !activeStation
    ? 0
    : wheelAlignment.wheels2.indexOf(activeStation.id) !== -1
    ? activeStation.expenses.wheelAlignment.wheels_2
    : wheelAlignment.wheels4.indexOf(activeStation.id) !== -1
    ? activeStation.expenses.wheelAlignment.wheels_4
    : 0;

  const shippingPrice = activeStation ? activeStation.expenses.shipping : -1;

  const shippingTime = activeStation ? activeStation.shippingTime : '';

  const crossSellProducts =
    crossSellProductStore && crossSellProductStore.length
      ? Object.assign(
          {},
          crossSellProductStore.map((csp) => ({ ...csp, productQty: product.qty })),
        )
      : null;

  const totalPrice = calculateStationTotalPrice(
    setPrice,
    activeStation,
    wheelAlignment,
    product,
    finalItemPrice,
    crossSellProductStore,
  );
  const totalPriceMatesRates = calculateStationTotalPrice(
    setPrice / 2,
    activeStation,
    wheelAlignment,
    product,
    finalItemPrice,
    crossSellProductStore,
  );
  const loading = initialLoading || loadingStationPrices;
  const isMobileFitter = (activeStation && activeStation.isMobileFitter) || false;
  const calloutFeePrice = calculateCalloutFeePrice(activeStation, product);

  let fittingNotAvailable = true;

  if (options.productType === types.TYRE_MOTO || options.productType === types.TYRE_CAR) {
    fittingNotAvailable = isFSFDisabled();
  }

  let sidebarPostcode = activeStation
    ? `${activeStation.state ? `${activeStation.state}, ` : ''}${activeStation.postcode}`
    : '';

  if (isMobileFitter) {
    let shippingState = localStorage.getItem('shippingState');
    shippingState = JSON.parse(shippingState)?.value;

    sidebarPostcode = localStorage.getItem('shippingPostcode');
    sidebarPostcode = JSON.parse(sidebarPostcode)?.value || '';
    sidebarPostcode = shippingState ? `${shippingState.toUpperCase()}, ${sidebarPostcode}` : sidebarPostcode;
  }
  setPaypalTotalPrice(totalPrice);

  if (product.hasAds) {
    loadAdPDP({ ...product, sku: product.id });
  }

  if ($(window).width() < 768) {
    const sidebarBottom = document.querySelector('#sidebar-bottom');

    const sidebarBottomContent = [
      getAddToCartRow({
        totalPrice: totalPrice,
        currencyIsoCode: options.currencyIsoCode,
        onAddClick: noop,
        baseUrl: options.baseUrl,
        tyreId: product.id,
        quantity: parseInt(product.qty),
        wheelAlignmentQuantity: wheelAlignmentQuantity,
        hasFitting: !!activeStation,
      }),
      !!activeStation &&
        getTotalRow({
          totalPrice: totalPrice,
          currencyIsoCode: options.currencyIsoCode,
          loading: loading,
        }),
    ];

    sidebarBottom.innerHTML = ReactDOMServer.renderToString(<>{sidebarBottomContent}</>);

    const addToCartBtn = document.querySelector('#sidebar-bottom .add-to-cart__button');
    addToCartBtn.addEventListener('click', (e) => {
      const addToCartProp = {
        tyreId: product.id,
        baseUrl: options.baseUrl,
        productQuantity: parseInt(product.qty),
        fittingStationId: activeStation ? activeStation.id : '',
        wheelAlignmentQuantity: wheelAlignmentQuantity,
        wheelAlignmentTwo: wheelAlignmentQuantity === 2,
        wheelAlignmentFour: wheelAlignmentQuantity === 4,
      };
      onAddToCartClick(e, addToCartProp);
    });

    document.addEventListener('scroll', () => {
      const isBtnVisible = isScrolledIntoView(document.querySelector('#pdp-sidebar .add-to-cart__button'));
      if (isBtnVisible) {
        sidebarBottom.style.opacity = '0';
      } else {
        sidebarBottom.style.opacity = '1';
      }
    });
  }

  return (
    <Pdp
      isMobileFitter={isMobileFitter}
      calloutFeePrice={calloutFeePrice}
      availableQuantities={product.availableQuantities}
      quantity={parseInt(product.qty)}
      price={product.price}
      currencyIsoCode={options.currencyIsoCode}
      setPrice={setPrice}
      fittingStationStreet={fittingStationStreet}
      fittingStationSuburb={fittingStationSuburb}
      sidebarPostcode={sidebarPostcode}
      fittingPrice={fittingPrice}
      wheelAlignmentQuantity={wheelAlignmentQuantity}
      wheelAlignmentPrice={wheelAlignmentPrice}
      fittingNotAvailable={fittingNotAvailable}
      hasFitting={!!activeStation}
      hasShipping={!!activeStation || shippingPrice !== -1}
      hasWheelAlignment={!!wheelAlignmentQuantity}
      shippingPrice={shippingPrice}
      shippingTime={shippingTime}
      totalPrice={totalPrice}
      totalPriceMatesRates={totalPriceMatesRates}
      fittingStationId={activeStation ? activeStation.id : ''}
      fittingPromotion={product.fittingPromotion}
      tyreId={product.id}
      buy4pay3={!voucherData && !!buy4pay3}
      cashback100={!!cashback100}
      clearance={!!clearance}
      loading={loading}
      baseUrl={options.baseUrl}
      quantityAndPriceRowVisible={quantityAndPriceRowVisible}
      onQuantityChange={onQuantityChange}
      onAddToCartClick={onAddToCartClick}
      onChangeStationClick={options.onChangeStationClick}
      onRemoveStationClick={options.onRemoveStationClick}
      onMoreInfoWheelAlignmentClick={onMoreInfoWheelAlignmentClick}
      onAddServiceFittingStationClick={options.onAddServiceFittingStationClick}
      onAddFittingServiceLearnMoreClick={options.onAddFittingServiceLearnMoreClick}
      onFittingNotAvailableLearnMoreClick={bind(onFittingNotAvailableLearnMoreClick, fittingNotAvailable)}
      onMatesRatesLearnMoreClick={showFriendbuyLightBox}
      onShowQuantityAndPriceClick={showQuantityAndPriceRow}
      isMpsProduct={isMpsProduct}
      mpsProductStock={mpsProductStock}
      priceDiscount={product.priceDiscount}
      getCalculatedDiscountAmount={getCalculatedDiscountAmount}
      onCalculate={show}
      crossSellProducts={crossSellProducts}
      onRemoveCrossSellClick={options.onRemoveCrossSellClick}
      onCrossSellClick={options.onCrossSellClick}
    />
  );
}

export const init = (container, options) => handleView(stores, render, getOptions(options), container);

const getOptions = (options) => ({
  ...options,
  onAddServiceFittingStationClick: bind(onAddServiceFittingStationClick, options.productType),
  onAddFittingServiceLearnMoreClick: bind(onAddFittingServiceLearnMoreClick, options.productType),
  onChangeStationClick: bind(onChangeStationClick, options.productType),
  onRemoveStationClick: bind(onRemoveStationClick),
  onRemoveCrossSellClick: bind(onRemoveCrossSellClick),
  onCrossSellClick: bind(onCrossSellClick),
});

function onMoreInfoWheelAlignmentClick() {
  showAction();
  open('PDP Sidebar');
}

const isMapAvailable = () => {
  loadGoogleMapDependencies();
};

const onFittingNotAvailableLearnMoreClick = (fittingNotAvailable) => {
  if (fittingNotAvailable === true) {
    showFsfNotAvailableLightBox();
  }
};

const onCrossSellClick = (e, obj) => {
  onCrossSellDetailsClick(obj);
};

let crossSellPreselectedPersistValues = [];
const onAddServiceFittingStationClick = (productType) => {
  if (productType === types.TYRE_MOTO) {
    openMotoFittingStationFinder();
  } else {
    isMapAvailable();
    TYROOLA.mapsInitiated.then(() => {
      setTimeout(() => {
        if (productType === types.TYRE_CAR) {
          LightboxActions.totalPagesChangeAction(FsfPages.WITH_SUCCESS_NOTIFICATION);
          const { appliedPostcode } = PostcodeStore.getState();
          const latLng = parseGoogleLatLng(MapStore.getState().latLng);
          if (
            typeof latLng.lat !== 'undefined' &&
            typeof latLng.lng !== 'undefined' &&
            appliedPostcode !== null &&
            validatePostcode(TYROOLA.globals.store, appliedPostcode)
          ) {
            const { stations } = FittingStationStore.getState();
            const hasCrossSellProducts = CrossSellProductStore.getState();
            const crossSellPreselectedValues = hasCrossSellProducts.map((csp) => ({ preselected: csp.preselected }));
            if (
              stations.length <= 0 ||
              JSON.stringify(crossSellPreselectedPersistValues) !== JSON.stringify(crossSellPreselectedValues)
            ) {
              crossSellPreselectedPersistValues = [...crossSellPreselectedValues];
              loadStations(appliedPostcode);
            }
            LightboxActions.openAction();
            LightboxActions.goToPageAction(FittingStationFinderConstants.LIGHTBOX_PAGE_FINDER);
          }
          openCarFittingStationFinder();
        }
      }, 500);
    });
  }
};

const onAddFittingServiceLearnMoreClick = (productType) => {
  if (productType === types.TYRE_MOTO) {
    openMotoFittingStationFinder();
  } else {
    isMapAvailable();
    TYROOLA.mapsInitiated.then(() => {
      if (productType === types.TYRE_CAR) {
        LightboxActions.totalPagesChangeAction(FsfPages.WITH_SUCCESS_NOTIFICATION);
        doAll(
          goToFsfPage(FittingStationFinderConstants.LIGHTBOX_PAGE_USAGE_DESCRIPTION),
          openCarFittingStationFinder(),
        );
      }
    });
  }
};

const calculateCalloutFeePrice = (activeStation, product) =>
  !!activeStation && activeStation.isMobileFitter && product.qty < 4 && activeStation.defaultCalloutFeeRaw
    ? activeStation.defaultCalloutFeeRaw
    : 0;

function calculateStationTotalPrice(
  setPrice,
  activeStation,
  wheelAlignment,
  product,
  finalItemPrice,
  crossSellProductStore,
) {
  const { voucherData } = TYROOLA.initialFluxStates;
  const expenses = activeStation ? activeStation.expenses : null;

  const services = {
    fitting: !!activeStation,
    shipping: !!activeStation,
    wheels_2: !!activeStation && wheelAlignment.wheels2.indexOf(activeStation.id) !== -1,
    wheels_4: !!activeStation && wheelAlignment.wheels4.indexOf(activeStation.id) !== -1,
    calloutFeePrice: calculateCalloutFeePrice(activeStation, product),
  };

  let total = setPrice;
  total = services.fitting ? total + expenses.fitting : total;
  total = services.shipping ? total + expenses.shipping : total;
  total = services.wheels_2 ? total + expenses.wheelAlignment.wheels_2 : total;
  total = services.wheels_4 ? total + expenses.wheelAlignment.wheels_4 : total;
  total = services.calloutFeePrice ? total + services.calloutFeePrice : total;
  total =
    !voucherData && !!product.buy4pay3 && featureFlags.FEATURE_TYRE_DEALS
      ? total - Math.floor(product.qty / 4) * finalItemPrice
      : total;
  total = featureFlags.FEATURE_SCA_25_PERCENT_DISCOUNT
    ? total - Math.floor(0.25 * finalItemPrice) * product.qty
    : total;

  if (!!crossSellProductStore) {
    crossSellProductStore.forEach((csp) => {
      if (csp.preselected) {
        total = total + (csp.syncQty ? csp.price * product.qty : csp.price);
      }
    });
  }

  if (!voucherData) {
    total -= getCalculatedDiscountAmount(product.priceDiscount, product.qty, finalItemPrice);
  }
  total -= getVoucherAmount(voucherData);

  return total;
}

function getVoucherAmount(voucherData) {
  let totalVoucher = 0;

  if (voucherData) {
    voucherData.allDiscounts.forEach((d) => {
      totalVoucher += parseInt(d.amount, 10);
    });
  }

  return totalVoucher;
}

function onQuantityChange(event) {
  const qty = parseInt(event.target.value, 10);
  const { id } = ProductsStore.getState()[0];
  const { stations } = FittingStationStore.getState();
  const { activeStation } = ActiveStationStore.getState();
  const { appliedPostcode } = PostcodeStore.getState();

  updateProduct({ id, qty });

  if (activeStation && !stations.length) {
    fetchInitialStationAction({ id, qty });
  } else if (activeStation && stations.length) {
    loadStations(activeStation.postcode);
  } else if (stations.length && appliedPostcode !== null) {
    loadStationsWithQuantity(appliedPostcode, qty);
  }

  updateVoucherData(id, qty);
}

function updateVoucherData(id, qty) {
  let voucherPDPData = null;
  const { voucherData } = TYROOLA.initialFluxStates;

  if (voucherData) {
    const crossSellProducts = CrossSellProductStore.getState();
    const hasCrossSellProducts = crossSellProducts && crossSellProducts.length;
    voucherPDPData = {
      qty: qty,
      id: id,
      crossSellProducts: hasCrossSellProducts
        ? crossSellProducts
            .filter((csp) => csp.preselected)
            .map((csp) => ({ spinachId: csp.spinachId, cartQty: csp.syncQty ? qty * 1 : 1 }))
        : undefined,
      idVouchers: voucherData && voucherData.allDiscounts ? voucherData.allDiscounts.map((d) => d.idVoucher) : [],
    };

    lockUi();
    addLoadingAction();
    ProductPage.onRedeemPDP(voucherPDPData, true);
  }
}

const getTotalPriceRow = (props) => (
  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
    <TotalPrice
      totalPrice={props.totalPrice}
      currencyIsoCode={props.currencyIsoCode}
      loading={props.loading}
      key="TotalPrice"
      labelExtraChildren={getGstInfo}
    />
  </div>
);

const getAddToCartRow = (props) => (
  <div className="sidebar__row-container--has-fitting" style={{ width: !props.hasFitting ? '100%' : '65%' }}>
    <AddToCart
      totalPrice={props.totalPrice}
      currencyIsoCode={props.currencyIsoCode}
      hasFitting={true}
      fittingNotAvailable={true}
      onAddClick={props.onAddClick}
      key="AddToCart"
      tyreId={props.tyreId}
      baseUrl={props.baseUrl}
      productQuantity={props.quantity}
      fittingStationId={'-1'}
      wheelAlignmentTwo={props.wheelAlignmentQuantity === 2}
      wheelAlignmentFour={props.wheelAlignmentQuantity === 4}
    />
  </div>
);

const getTotalRow = (props) => (
  <div className="sidebar__row-container" style={{ width: '30%' }}>
    <button className="add-to-cart__button" style={{ lineHeight: '18px', backgroundColor: 'transparent' }}>
      <Translation translationKey="pdp-sidebar-fitted-total-label" />
      <Price
        key="pdp-top-total"
        name="pdp-top-total"
        price={props.totalPrice}
        loading={props.loading}
        currencyIsoCode={props.currencyIsoCode}
        label={''}
      />
    </button>
  </div>
);

function onAddToCartClick(e, props) {
  if (TYROOLA.initialFluxStates?.product?.clearance) {
    showClearanceLightbox(true);
    window.addToCartDeferred = $.Deferred();
    window.addToCartDeferred.then(() => addProductToCart(props));
  } else {
    addProductToCart(props);
  }
}

async function addProductToCart(props) {
  await _prepareCartRequest(props);
  window.location = `${location.origin}${TYROOLA.globals.baseUrl}/cart/`;
}

function _prepareCartRequest(props) {
  const wheelAlignmentTwo = props.wheelAlignmentTwo ? 1 : 0;
  const wheelAlignmentFour = props.wheelAlignmentFour ? 1 : 0;

  return ActiveStationsActions.addProductToCartAction(
    { id: props.fittingStationId, qty: props.productQuantity },
    props.tyreId,
    false,
    true,
    wheelAlignmentTwo,
    wheelAlignmentFour,
  );
}

const isScrolledIntoView = (elem) => {
  var docViewTop = $(window).scrollTop();
  var docViewBottom = docViewTop + $(window).height();

  var element = $(elem);
  if (element && element.offset() && element.offset().top) {
    var elemTop = element.offset().top;
    var elemBottom = elemTop + element.height();

    return elemTop < docViewBottom && elemBottom >= docViewTop;
  }
  return false;
};
